var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPending({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15,
    height: 14,
    viewBox: "0 0 15 14",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 0.333008C11.18 0.333008 14.1667 3.31967 14.1667 6.99967C14.1667 10.6797 11.18 13.6663 7.5 13.6663C3.82 13.6663 0.833334 10.6797 0.833334 6.99967C0.833334 3.31967 3.82 0.333008 7.5 0.333008ZM7.5 12.333C10.4467 12.333 12.8333 9.94634 12.8333 6.99967C12.8333 4.05301 10.4467 1.66634 7.5 1.66634C4.55333 1.66634 2.16667 4.05301 2.16667 6.99967C2.16667 9.94634 4.55333 12.333 7.5 12.333ZM9.85733 3.69967L10.8 4.64234L7.5 7.94234L6.55733 6.99967L9.85733 3.69967Z",
    fill: "#6A6A6A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPending);
export default __webpack_public_path__ + "static/media/pending.0b6c6f98b34430cba7f45686645f046f.svg";
export { ForwardRef as ReactComponent };